import * as yup from 'yup';

const facilityMenuSchema = yup.object({
  order: yup.number().required().label('Name').default(0),
  label: yup.string().required().label('Name').default(''),
  link: yup.string().label('Link').default(''),
});

export default facilityMenuSchema;
